import logoImg from "@/assets/logo.png";

export const BUSINESS = {
  name: "Trusted Notary Illinois",
  owner: "Andreas Aigner",
  role: "Notary Public — State of Illinois",
  tagline: "Mobile Notary Service — I Come To You",
  city: "River Grove, IL 60171",
  serviceArea: "Western & northwest Chicago suburbs",
  phoneDisplay: "(708) 665-6921",
  phoneHref: process.env.REACT_APP_BUSINESS_PHONE || "+17086656921",
  smsHref: `sms:${process.env.REACT_APP_BUSINESS_PHONE || "+17086656921"}`,
  email: process.env.REACT_APP_BUSINESS_EMAIL || "trustednotaryillinois@gmail.com",
  bookingUrl:
    process.env.REACT_APP_SQUARE_BOOKING_URL ||
    "https://book.squareup.com/appointments/1olo7t34i26d5w/location/L0FQSYD6WXQXR/services",
  logoUrl: logoImg,
};

export const SERVICES = [
  { title: "Acknowledgments & Jurats", desc: "Standard notarial acts for signed statements and affidavits." },
  { title: "Affidavits & Sworn Statements", desc: "Sworn documents where the signer must appear in person." },
  { title: "Powers of Attorney", desc: "General, financial, healthcare, and limited POA documents." },
  { title: "Real Estate Deeds", desc: "Quitclaim, warranty, and other property transfer documents." },
  { title: "Loan & Refinance Signings", desc: "Full purchase and refinance packages for lenders and title companies." },
  { title: "Auto Loan & Title Documents", desc: "Vehicle titles, bills of sale, and lienholder paperwork." },
  { title: "Contracts & Agreements", desc: "Business contracts, leases, and personal agreements." },
  { title: "Child Custody, Divorce & Family", desc: "Parenting agreements, family law and divorce documents." },
  { title: "Adoption Documents", desc: "Consent forms and adoption-related notarizations." },
  { title: "International Documents", desc: "Signature notarization on documents destined for use abroad." },
];

export const ZONES = [
  {
    key: "A",
    range: "0–5 mi",
    fee: 50,
    towns: [
      "River Grove", "Elmwood Park", "Franklin Park", "Schiller Park",
      "River Forest", "Melrose Park", "Stone Park", "Northlake",
      "Norridge/Harwood Heights", "Forest Park", "Oak Park", "Maywood",
    ],
  },
  {
    key: "B",
    range: "6–10 mi",
    fee: 65,
    towns: [
      "Bellwood", "Berkeley", "Hillside", "Broadview", "Bensenville",
      "Rosemont", "Des Plaines", "Park Ridge", "Niles", "Cicero", "Berwyn",
      "Westchester", "Elmhurst", "Chicago (Portage Park / Jefferson Park / Austin)",
    ],
  },
  {
    key: "C",
    range: "11–15 mi",
    fee: 80,
    towns: [
      "Addison", "Villa Park", "Lombard", "Oak Brook", "Elk Grove Village",
      "Wood Dale", "La Grange", "Skokie", "Morton Grove", "Lincolnwood",
      "Chicago (Downtown/Loop, Lincoln Park, Wicker Park)",
    ],
  },
  {
    key: "D",
    range: "16–20 mi",
    fee: 100,
    towns: [
      "Wheaton", "Glen Ellyn", "Downers Grove", "Mount Prospect",
      "Arlington Heights", "Schaumburg", "Carol Stream", "Evanston", "Wilmette",
    ],
  },
  {
    key: "E",
    range: "21–25 mi",
    fee: 125,
    towns: [
      "Naperville", "West Chicago", "Hoffman Estates", "Palatine",
      "Hanover Park", "Glenview", "Northbrook", "Winnetka",
      "Chicago (Rogers Park, Edgewater)",
    ],
  },
];

export const FLAT_FEES = [
  { title: "Single Document Notarization", price: "from $50", detail: "One signature at your Zone A location." },
  { title: "Loan Signing (Purchase or Refinance)", price: "$125", detail: "Full lender/title package." },
  { title: "Seller / Refinance Package Signing", price: "$150", detail: "Complete seller or refi package." },
  { title: "Hospital / Care Facility Visit", price: "from $75", detail: "Bedside notarization for alert signers." },
];

export const ADD_ONS = [
  { label: "Additional signature", price: "+$5" },
  { label: "Evening (after 6 PM)", price: "+$15" },
  { label: "Weekend", price: "+$20" },
  { label: "Rush / same-day", price: "+$25" },
];

export const FAQS = [
  {
    q: "What is a mobile notary?",
    a: "I travel to your location to notarize documents, so you don't have to find a notary or leave home or work.",
  },
  {
    q: "What do I need to bring?",
    a: "The unsigned document(s) and a valid, current government-issued photo ID for each signer.",
  },
  {
    q: "How much does it cost?",
    a: "A travel/convenience fee based on your distance from River Grove, plus $5 per notarized signature (the Illinois statutory fee). See Pricing for full details.",
  },
  {
    q: "What areas do you serve?",
    a: "River Grove and the western & northwest Chicago suburbs. Farther locations by custom quote — just call.",
  },
  {
    q: "Can you notarize at a hospital or nursing home?",
    a: "Yes — as long as the signer is alert, aware, and able to communicate their intent, and has valid photo ID.",
  },
  {
    q: "Do you do loan signings?",
    a: "Yes — purchase, refinance, and seller packages are all welcome.",
  },
  {
    q: "Are you available evenings and weekends?",
    a: "Yes, by appointment. A small after-hours fee applies.",
  },
];

export const LEGAL_DISCLOSURE =
  "Andreas Aigner is a commissioned Notary Public in the State of Illinois. A notary public is not an attorney and may not give legal advice or accept fees for legal advice. The maximum fee for a notarial act in Illinois is $5.00 per signature; all other fees are for mobile/travel service. Prices subject to change.";
